import React from 'react';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { observer } from 'src/utils/mobx-react';
import { RouteViewType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { GoogleTagManagerState } from 'src/domains/layouts/state/googleState/GoogleTagManagerState';
import { useCommon } from 'src/domains/common/Common';

interface PropsType {
    to?: RouteViewType | RightHandSideViewType | string;
    children?: React.ReactNode;
    className?: string;
    size?: 'large' | 'medium' | 'small' | 'xs';
    isButton?: boolean;
    onClickCallback?: () => void;
    onMouseEnter?: (e: React.SyntheticEvent) => void;
    dataTest?: string;
    routeNameForGtm: string | null;
}

export const AccountNavigationLink = observer('AccountNavigationLink', (props: PropsType) => {
    const common = useCommon();

    const handleOnClickWithGTM = (): void => {
        if (props.onClickCallback !== undefined) {
            props.onClickCallback();
        }

        if (props.routeNameForGtm === null) {
            return;
        }
        const gtm = GoogleTagManagerState.get(common);
        gtm.routingAccountChange('account-summary');
    };

    return (
        <Link
            className={props.className}
            dataTest={props.dataTest}
            isButton={props.isButton}
            onClick={handleOnClickWithGTM}
            onMouseEnter={props.onMouseEnter}
            size={props.size}
            to={props.to}
        >
            {props.children}
        </Link>
    );
});
